// client/src/components/CashierNavbar.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaHome, FaUser, FaTags } from 'react-icons/fa';
import { SidebarBrand } from '../shared/BrandLogo';
import '../CSS/Navbar.css';

const CashierNavbar = () => {
  return (
    <div className="sidebar-container">
      <SidebarBrand label="Espace caisse" />
      <div className="sidebar-item">
        <NavLink
          to="/cashierdashboard"
          end
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          <FaHome size={20} />
          <span>Accueil</span>
        </NavLink>
      </div>

      <div className="sidebar-item">
        <NavLink
          to="/cashierpromo"
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          <FaTags size={20} />
          <span>Offres</span>
        </NavLink>
      </div>

      <div className="sidebar-item">
        <NavLink
          to="/cashiersettings"
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          <FaUser size={20} />
          <span>Profil</span>
        </NavLink>
      </div>
    </div>
  );
};

export default CashierNavbar;
